import $ from 'jquery';
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { MsSupportChatModal } from '@bingads-webui-react/ms-support-chat-modal';
import { getRegion } from './utils';

export const msSupportChatLocalization = {
  MsSupportChatModal_Continue: _TL_('Continue'),
  MsSupportChatModal_Cancel: _TL_('Cancel'),
  MsSupportChatModal_Close: _TL_('Close'),
  MsSupportChatModal_Title: _TL_('Start a live chat'),
  MsSupportChatModal_Description: _TL_('Description'),
  MsSupportChatModal_Description_Placeholder: _TL_('Add more information so we can help you quickly.'),
  MsSupportChatModal_VirtualAgent_WelcomeMessage: _TL_("Hi! I'm a Microsoft Advertising Virtual Agent. I'd love to help you. Please do not include any sensitive information during our conversation."),
  MsSupportChatModal_DialogReadyLabel: _TL_('Start a live chat dialog is ready'),
  MsSupportChatModal_BR_Alert: _TL_('We are currently experiencing high volume of Portuguese chat requests. In the meantime, you can go back to the help menu and request English support that is available 24/7.'),
  MsSupportChatModal_EN_Alert: _TL_('We are experiencing higher than normal chat volume and will assist you as soon as possible. Thank you for your patience.'),
  RequestCallModal_ReasonForCall: _TL_('How can we help you?'),
  RequestCallModal_AdvertiserSupport: _TL_('I need help with Microsoft Advertising or have a general question'),
  RequestCallModal_AgencySupport: _TL_('I am an agency managing clients on Microsoft Advertising'),
  RequestCallModal_ComplexSupportScenario: _TL_('I have a question about Microsoft Shopping campaign or conversion tracking'),
  RequestCallModal_OptimizationConsult: _TL_('I want coaching on how to optimize my campaign performance'),
  RequestCallModal_SmartCampaign: _TL_('I need help with Smart campaigns or have a general question'),
  RequestCallModal_DMCSupport: _TL_('I need help with Digital Marketing Center or have a general question'),
  RequestCallModal_UPSupport: _TL_('I need help with Multiplatform campaigns or have a general question'),
  RequestCallModal_SmartPageSupport: _TL_('I need help with Smart Pages or have a general question'),
  Warning: _TL_('Warning'),
};

export const RequestChatSupport = (props) => {
  const {
    activity,
    i18n,
    isCopilotEnabled,
    currentAccount,
    permissions,
    supportOptions,
    featureName,
    portalClassName,
    flowId,
  } = props;
  const [open, setOpen] = useState(false);
  const [market, setMarket] = useState(undefined);
  const legacyi18n = useMemo(() => buildLegacyI18n(i18n, [msSupportChatLocalization], []), [i18n]);
  const accountNumber = currentAccount && currentAccount.AccountNumber;
  const [onCancelCallback, setOnCancelCallback] = useState(null);
  const { IfShowLiveChat } = supportOptions;

  const onClose = useCallback(() => {
    setOpen(false);
    if (onCancelCallback) {
      onCancelCallback();
    }
  }, [onCancelCallback]);

  const chatCopilotTrigger = useCallback(() => {
    activity.trace(`${getRegion(i18n)} copilot live agent support triggered from ms-chat-support`);

    const detail = {
      eventType: 'action',
      eventData: {
        ActionId: 'liveAgentSupport',
        FlowId: 'Copilot-Help-GetStarted-StartLiveChat',
      },
    };

    document.dispatchEvent(new CustomEvent('copilotToggleEvent', { detail }));
    if (_.isFunction(window.apex_glb.closeHelpView)) {
      window.apex_glb.closeHelpView();
    }
  }, [activity, i18n]);

  useEffect(() => {
    let cancelled = false;
    const handler = (e, data) => {
      if (isCopilotEnabled) {
        chatCopilotTrigger();
      } else {
        setOnCancelCallback(data && data.onCancel);
        /* istanbul ignore next */
        if (!cancelled) {
          setOpen(true);
          if (!_.isEqual(market, data && data.market)) {
            setMarket(data && data.market);
          }
        }
      }
    };

    $('.livechat-text-block, .ms-support-chat__text-block, #msSupportChatTrigger').on('click', handler);
    return () => {
      cancelled = true;
      $('.livechat-text-block, .ms-support-chat__text-block, #msSupportChatTrigger').off('click', handler);
    };
  }, [market, chatCopilotTrigger, isCopilotEnabled]);

  if (!IfShowLiveChat) return (null);

  return (
    <div>
      <div id="msSupportChatTrigger" className="livechat-text-block ms-support-chat__text-block" />
      <div id="msSupportChatModalContainer">
        <MsSupportChatModal
          {...props}
          isOpen={open}
          onClose={onClose}
          i18n={legacyi18n}
          context={{ accountNumber, flowId }}
          featureName={featureName}
          portalClassName={portalClassName}
          permissions={permissions}
          market={market}
        />
      </div>
    </div>
  );
};

RequestChatSupport.propTypes = {
  supportOptions: PropTypes.shape({}).isRequired,
  currentAccount: PropTypes.shape({}),
  permissions: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  featureName: PropTypes.string,
  portalClassName: PropTypes.string,
  flowId: PropTypes.string,
  activity: PropTypes.shape({}).isRequired,
  isCopilotEnabled: PropTypes.bool,
};

RequestChatSupport.defaultProps = {
  flowId: 'advertiser',
  currentAccount: {},
  featureName: undefined,
  portalClassName: undefined,
  isCopilotEnabled: false,
};
